import { useState, useEffect } from 'react';

// material-ui
import {
    Button,
    Grid
} from '@mui/material';

// project imports
import TurfList from './TurfList';
import AddTurf from './AddTurf';
import useApi from 'hooks/useApi';
import VenueService from 'services/VenueService';

// assets
import AddIcon from '@mui/icons-material/Add';

export default function Turf({ venueUuid, venueDetails, sportsTypes, setSportsType }) {

    const [open, setOpen] = useState(false);
    const [rows, setRows] = useState([]);
    const [reload, setReload] = useState(false);
    const [selectedTurf, setSelectedTurf] = useState(null);

    const handleClickOpen = (turfUuid) => {
        if (turfUuid) {
            getTurfByUuidApi.execute(turfUuid);
        } else {
            setOpen(true);
        }
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedTurf(null);
    };

    const getTurfListHandler = (response) => {
        const data = response.data;
        setRows(data.rows);
    };

    const getTurfHandler = (response) => {
        setSelectedTurf(response.data);
        setOpen(true);
    };

    const getTurfListApi = useApi(VenueService.getTurfList, getTurfListHandler);
    const getTurfByUuidApi = useApi(VenueService.getTurfByUuid, getTurfHandler);

    useEffect(() => {
        getTurfListApi.execute({
            venueUuid
        });
    }, [reload]);

    return (
        <>
            <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
                <Grid item xs={12} sm={12} sx={{ textAlign: 'right' }}>
                    <Button startIcon={<AddIcon />} variant='contained' onClick={() => handleClickOpen()} color='secondary'>Add Court</Button>
                </Grid>
            </Grid>
            <TurfList
                rows={rows}
                setReload={setReload}
                handleClickOpen={handleClickOpen}
                sportsTypes={sportsTypes}
            />
            <AddTurf
                selectedTurf={selectedTurf}
                open={open}
                handleClose={handleClose}
                setReload={setReload}
                venueDetails={venueDetails}
                venueUuid={venueUuid}
                sportsTypes={sportsTypes}
                setSportsType={setSportsType}
            />
        </>
    );
};